import { useEffect, useState } from 'react';

/** Now, ticking once a second while `active`: the steps line's clock. */
export function useNow(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [active]);
  return now;
}

/**
 * When `active` last turned on, or null while it is off: how long the
 * current wait on the model has run ("Thinking." and its time).
 */
export function useSince(active: boolean): number | null {
  const [since, setSince] = useState<number | null>(null);
  useEffect(() => {
    setSince(active ? Date.now() : null);
  }, [active]);
  return since;
}
